<template>
    <v-layout class="my-4 border">
        <v-flex class="pa-2">
            <accessible-radio-group
                v-model="value"
                :outline="outline"
                :name="metadata.name"
                :data-meta-id="metadata.id"
                :label="Question"
                :options="[
                    { label: $t('base.yes'), value: 1 },
                    { label: $t('base.no'), value: 0 },
                ]"
                :mandatory="required"
                :rules="[
                    (v) =>
                        v === 0 ||
                        v === 1 ||
                        $t('base.errors.requiredField'),
                ]"
                :id="metadata.name"
                @input="emitValue"
            />
        </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import _ from 'lodash';
import AccessibleRadioGroup from '@/components/inputs/AccessibleRadioGroup.vue';

export default {
    name: 'phx-covid-asked-to-get-a-screening-test',
    components: { AccessibleRadioGroup },
    mixins: [formRules],
    props: {
        metadata: { type: Object, required: true },
        outline: { type: Boolean, required: false, default: false },
        required: { type: Boolean, required: false, default: false },
        value: { type: Number, required: true },
        withIcon: { type: Boolean, required: false, default: false },
    },
    data() {
        return {
            selected: null,
        };
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        Question() {
            return _.replace(this.$t('form.phxCovidAskedToGetAScreeningTestQuestion'),
                /%domain%/g,
                this.Link
            );
        },
        Link() {
            return _.constant('https://voyage.gc.ca/voyage-covid');
        },

    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },
    },
};
</script>

<style lang="scss" scoped>
.border::v-deep {
    border: 2px solid var(--v-border-metadata-color)!important;
    border-radius: 4px!important;
}
.v-radio label {
  font-size: 14px;
}

.v-radio.selected label {
  color: black;
}

.v-input--radio-group label {
  font-size: 14px;
}
.hint {
  font-size: 14px;
  font-weight: 300;
  color:rgba(0,0,0,.84);
}
.question {
  font-size: 16px;
  color:rgba(0,0,0,.64);
  margin-bottom: 1rem;
  font-weight: 200;
}
strong{
    font-weight: bold !important;
}
</style>
